import React from "react";
import DocumentService from "../../../../../services/DocumentService";
import { activeFilterPageInfo } from "../../../../../services/FilteringUtils";
import WebServiceConsumer from "../../../../../services/WebServiceConsumer";
import {
  knowledgeItemValidationRules as validationRules,
  validateEntity
} from "../../../../../validators/validationRules";
import TableComponent from "../../../page/TableComponent";
import Document from "./Document";

class DocumentContainer extends TableComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      documentForUpload: {},
      disabled: true,
      selectedDocument: {},
      showEditDialog: false
    };

    this.documentService = new DocumentService();
    this.serviceConsumer = new WebServiceConsumer();
    this.fileUploaderRef = React.createRef();
  }

  possibleSizesPerPage() {
    return [3, 5, 10];
  }

  loadData = pageInfo => {
    const entity = this.props.entity;
    if (entity && entity._links) {
      this.documentLoading = true;
      const url = entity._links.documents.href;
      const documentFilterInfo = {
        ...pageInfo,
        ...activeFilterPageInfo
      };
      const sortInfo = {
        orderBy: "id",
        direction: "desc"
      };
      this.prepareCall(
        this.documentService.getEntitiesWithParams(
          url,
          documentFilterInfo,
          sortInfo,
          this.onDataLoad,
          this.messageHandler.handleError
        )
      );
      this.performCalls();
    }
  };

  onDownloadClick = document => {
    this.prepareCall(
      this.documentService.downloadDocument(
        document._links.download.href,
        document.name,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onRowClick = (_, row) => {
    const selfUrl = row._links.self.href;
    this.prepareCall(
      this.documentService.getEntitiesByUrl(
        selfUrl,
        this.onDocumentLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDocumentLoad = data => {
    const document = data;
    this.handleShowEditDialog();
    document.noDateRange = true;
    this.setState({
      selectedDocument: { ...document },
      oldDocument: { ...document }
    });
  };

  onDeleteClick = (document, onSuccess) => {
    this.prepareCall(
      this.documentService.deleteEntity(
        document,
        undefined,
        this.onDeleteSuccess,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onDeleteSuccess = () => {
    this.onDeleteSuccessMessage();
    this.loadData(this.state.pageInfo);
  };

  onUploadClick = files => {
    var documentForUpload = this.state.documentForUpload;
    documentForUpload["fileName"] = files[0].name;
    documentForUpload["contentType"] = files[0].type;
    documentForUpload["extension"] = {
      id: files[0].name.substr(files[0].name.lastIndexOf(".") + 1).toUpperCase()
    };
    documentForUpload["entities"] = [this.props.entity];

    this.prepareCall(
      this.documentService.postDocument(
        documentForUpload,
        files,
        this.onUploadSuccess,
        message => {
          this.messageHandler.handleError(message);
          this.fileUploaderRef.current.onError();
        }
      )
    );
    this.performCalls();
  };

  onUploadSuccess = newDocument => {
    this.fileUploaderRef.current.reset();
    this.onSaveSuccessMessage();
    this.setState({ documentForUpload: {} });
    this.startLoading(this.state.pageInfo, this.sortInfo);
  };

  onSave = event => {
    this.prepareCall(
      this.documentService.patchEntity(
        this.state.selectedDocument,
        this.state.oldDocument,
        this.onSaveResponse,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onSaveResponse = data => {
    this.onSaveSuccessMessage();
    this.loadData(this.state.pageInfo);
    this.handleCloseEditDialog();
  };

  onChange = event => {
    var documentForUpload = this.state.documentForUpload;
    documentForUpload[event.target.id] = event.target.value;
    const disabled = !this.validator(documentForUpload);
    this.setState({
      documentForUpload: documentForUpload,
      disabled: disabled
    });
  };

  onDocumentEditChange = event => {
    var documentForUpdate = this.state.selectedDocument;
    documentForUpdate[event.target.id] = event.target.value;
    const disabled = !this.validator(documentForUpdate);
    this.setState({
      selectedDocument: documentForUpdate,
      disabled: disabled
    });
  };

  validator = entity => {
    return validateEntity(entity, validationRules.document);
  };

  handleShowEditDialog = () => {
    this.setState({ showEditDialog: true });
  };

  handleCloseEditDialog = () => {
    this.setState({ showEditDialog: false });
  };

  render() {
    const paginationOptions = this.constructPaginationOptions();

    const maxLength = {
      name: 255,
      description: 2000
    };

    return (
      <Document
        documents={this.state.content}
        onDocumentDownload={this.onDownloadClick}
        onDocumentsUpload={this.onUploadClick}
        onDocumentDelete={this.onDeleteClick}
        fileUploaderRef={this.fileUploaderRef}
        documentForUpload={this.state.documentForUpload}
        onChange={this.onChange}
        disabled={this.state.disabled}
        validationRules={validationRules.document}
        paginationOptions={paginationOptions}
        handleTableChange={this.onFilteringChange}
        maxLength={maxLength}
        onSave={this.onSave}
        entity={this.props.entity}
        onRowClick={this.props.editable ? this.onRowClick : undefined}
        editable={this.props.editable}
        selectedDocument={this.state.selectedDocument}
        onDocumentEditChange={this.onDocumentEditChange}
        showEditDialog={this.state.showEditDialog}
        handleCloseEditDialog={this.handleCloseEditDialog}
      />
    );
  }
}

export default DocumentContainer;
